// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import { StyledTableRow } from "./TableRow.styled";

// #####################################################

export const StyledTableBody = styled("tbody")`
	${StyledTableRow}:not(:last-child) {
		border-bottom: var(--size-grid-small) solid
			${({ theme: { colors } }) => colors.buttonsDefaultGrey};
	}
`;

// #####################################################
